import { Stack, Text } from "@skailer-com/uikit";
import { FieldErrors, FieldValues } from "react-hook-form";

export interface ServerErrorFieldProps<TFieldValues extends FieldValues = FieldValues> {
  errors: FieldErrors<TFieldValues>;
}

export function ServerErrorField<TFieldValues extends FieldValues = FieldValues>({
  errors,
}: ServerErrorFieldProps<TFieldValues>) {
  return (
    <>
      {errors.root?.serverError && (
        <Stack className={"h-14"} justify={"center"}>
          <Text className={"text-danger"}>{errors.root.serverError.message || "Error"}</Text>
        </Stack>
      )}
    </>
  );
}
